import React from "react";
import "./navItem.css";

function NavItem({ nav, isSelected, subSectionId, onClick }) {
  const className = `nav-link collapsed ${isSelected ? "selected" : ""}`;
  const ulClassName = isSelected ? "show" : "";
  const target = /*nav.subs?.length > 0 ? */ `${nav.name}-nav`; /* : ""*/
  const pawTarget = target.length > 0 ? `#${target}` : "#";
  const subs = nav.subs?.length > 0 ? nav.subs : [];
  return (
    <li className="nav-item">
      <a
        href="#"
        className={className}
        onClick={() => onClick(nav, null)}
        data-bs-target={pawTarget}
        data-bs-toggle="collapse"
        aria-expanded={isSelected}
      >
        <i className={nav.icon}></i>
        <span>{nav.name}</span>
        {nav.subs?.length > 0 && <i className="bi bi-chevron-down ms-auto"></i>}
      </a>

      {nav.subs?.length > 0 && (
        <ul
          className={`nav-content collapse ${ulClassName}`}
          id={target}
          data-bs-parent="#sidebar-nav"
        >
          {subs.map((sub, index) => {
            const isSelected = sub._id === subSectionId;

            const className = ` ${isSelected ? "selected" : ""}`;
            return (
              <a
                key={index}
                href="#"
                onClick={() => onClick(nav, sub)}
                className={className}
              >
                <i className={sub.icon}></i>
                <span>{sub.name}</span>
              </a>
            );
          })}
        </ul>
      )}
    </li>
  );
}

export default NavItem;
